<div class="grid-row">
  <div
    *ngIf="sideMenu.sideNavItems.length > 0"
    class="tablet:grid-col-3 margin-bottom-3 tablet:margin-bottom-0 tablet:margin-right-6"
  >
    <art-side-navigation
      (menuItemSelected)="onSideNavItemSelected($event)"
      [sideMenu]="sideMenu"
    ></art-side-navigation>
  </div>
  <!-- Will display all ICT FORM 1..10-->
  <div class="tablet:grid-col-8 tablet:margin-bottom-0">
    <div
      #formGroupAnchor
      *ngFor="
        let eachFormConfig of formConfig;
        let outerIndex = index;
        let last = last
      "
      [ngClass]="{
        'ogp-display-none': outerIndex !== navIndex,
        'ogp-display-bloc': outerIndex === navIndex
      }"
    >
      <form
        [formGroup]="formList[outerIndex]"
        (ngSubmit)="onFormSubmit(outerIndex)"
        [hidden]="outerIndex !== navIndex"
      >
        <!-- For each form, it will list all the control or form element-->
        <div
          [hidden]="outerIndex !== navIndex"
          class="grid-row"
          [ngClass]="{
            'flex-row': eachFormConfig.formButtons.add,
            'flex-align-end': eachFormConfig.formButtons.add,
            'flex-column': !eachFormConfig.formButtons.add
          }"
        >
          <div
            *ngFor="
              let eachControl of allControlList[outerIndex];
              let index = index;
              let first = first
            "
            class="form-section"
            id="form-section-{{
              eachFormConfig.formElements[0].formSectionId
                ? eachFormConfig.formElements[0].formSectionId
                : controlList.length * outerIndex + index
            }}"
            #formSection
          >
            <h1
              *ngIf="
                !eachFormConfig.formElements[index].hidden &&
                eachFormConfig.formElements[index].formSection
              "
              class="margin-bottom-2"
              [ngClass]="{ 'margin-top-3': 'index!==first' }"
              id="{{ eachFormConfig.formElements[index].controlName }}"
            >
              <b>{{ eachFormConfig.formElements[index].formSection }}</b>
            </h1>
            <h3
              *ngIf="
                !eachFormConfig.formElements[index].hidden &&
                eachFormConfig.formElements[index].formsectionText
              "
              id="{{ eachFormConfig.formElements[index].controlName }}"
            >
              {{
                eachFormConfig.formElements[index].formsectionText &&
                  eachFormConfig.formElements[index].formsectionText
              }}
            </h3>
            <div
              class="margin-top-2"
              *ngIf="!eachFormConfig.formElements[index].hidden"
            >
              <art-text-field
                *ngIf="
                  eachFormConfig.formElements[index].elementType === 'text'
                "
                [formData]="eachFormConfig.formElements[index]"
                [hidden]="false"
                (eltClicked)="
                  onElementClick(
                    $event,
                    outerIndex,
                    eachFormConfig.formElements[index].controlName
                  )
                "
                [control]="eachControl"
              >
              </art-text-field>
              <!-- Radio Button Group -->
              <div
                *ngIf="
                  eachFormConfig.formElements[index].elementType ===
                    'radioButtonGroup' &&
                  !eachFormConfig.formElements[index].hidden
                "
              >
                <art-radiobutton-group
                  [formData]="eachFormConfig.formElements[index]"
                  [hidden]="false"
                  (eltClicked)="
                    onElementClick(
                      $event,
                      outerIndex,
                      eachFormConfig.formElements[index].controlName
                    )
                  "
                  [formGroup]="eachControl"
                ></art-radiobutton-group>
              </div>
              <art-checkbox-group
                *ngIf="
                  eachFormConfig.formElements[index].elementType ===
                    'checkboxGroup' &&
                  !eachFormConfig.formElements[index].hidden
                "
                [formData]="eachFormConfig.formElements[index]"
                [formGroup]="eachControl"
                [dataUpdated]="eltUpdated"
                (eltClicked)="
                  onElementClick(
                    $event,
                    outerIndex,
                    eachFormConfig.formElements[index].controlName
                  )
                "
              >
              </art-checkbox-group>
            </div>
          </div>
          <div
            tabindex="0"
            aria-label="Content is loading, additional information is being displayed"
            class="ogp-flex-center"
            *ngIf="loading"
          >
            <div class="lds-ripple">
              <div></div>
              <div></div>
            </div>
          </div>
          <!-- This button will be disable if the form is not valid and if the value is null-->
          <button
            *ngIf="eachFormConfig.formButtons.add"
            [disabled]="
              !formList[outerIndex].valid || formList[outerIndex].value === null
            "
            id="art-add-btn for index {{ outerIndex }}"
            aria-label="Add an ICT Item"
            class="usa-button usa-button--accent-warm art-add-btn"
            type="submit"
          >
            {{ eachFormConfig.formButtons.add }}
          </button>
        </div>
      </form>
      <br />
      <!-- Will display the information box to tell the user the form is completed when all field on that form are checked-->
      <div
        *ngIf="formCompletetion[this.navIndex] === true"
        class="usa-alert usa-alert--info usa-alert--no-icon margin-bottom-3 margin-top-neg-1"
      >
        <div class="usa-alert__body">
          <p class="usa-alert__text">You have completed the form.</p>
        </div>
      </div>
    </div>
    <div
      *ngIf="this.router.url.includes('form-page') && showButtonControls"
      class="ogp-flex"
    >
      <div>
        <art-button
          class="ogp-btn"
          [disabled]="navIndex === 0"
          [buttonData]="backButton"
          (click)="navBackForm()"
        >
        </art-button>
        <art-button
          class="ogp-btn"
          *ngIf="navIndex <= formConfig.length - 2"
          [buttonData]="nextButton"
          (click)="navNextForm()"
        >
        </art-button>

        <button
          *ngIf="navIndex === formConfig.length - 1"
          [disabled]="formCompletetion[this.navIndex] === false"
          class="ogp-btn usa-button usa-button--accent-warm"
          type="submit"
          (click)="onFormSubmit(0)"
        >
          {{ formConfig[0].formButtons.submit }}
        </button>
        <button
          class="ogp-btn usa-button usa-button--secondary ogp-btn-delete"
          type="button"
          (click)="deleteICT()"
          *ngIf="navIndex > 0"
          aria-label="Delete Current ICT"
        >
          Delete Current ICT
        </button>
      </div>
      <div class="ogp-btn" *ngIf="formConfig[0].formButtons.submit">
        <art-save-json
          [saveAsInfo]="{ btnName: 'Save (.json)', fileName: 'jsonData.json' }"
          [ictItem]="currentFormData"
        ></art-save-json>
        <!-- <button
                    (click)="onReset()"
                    class="usa-button usa-button--secondary"
                    type="button">Clear Form
                </button> -->
      </div>
    </div>
    <div class="error-summary margin-top-2" *ngIf="errorSummary.length > 0">
      <!-- <h2>Form Errors</h2> -->
      <p>
        <b>Form Errors-</b> you must complete all the questions in order to get
        the 508 results. Select the links below to go to the unanswered
        question(s)
      </p>
      <ul>
        <li
          *ngFor="let error of errorSummary"
          (click)="scrollToSection(error.controlName)"
        >
          <div *ngIf="error.message">
            <ng-container *ngIf="error.message?.maxlength">
              <b>{{ getSectionLabel(error.section) }}: </b>
              {{ " " + error.message?.maxlength }}
            </ng-container>
            <ng-container
              *ngIf="!error.message?.maxlength && error.message?.required"
            >
              <b>{{ getSectionLabel(error.section) }}: </b>
              {{ " " + error.message?.required }}
            </ng-container>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
